import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MessageSquare, Users, TrendingUp, Clock } from 'lucide-react';

const Dashboard = () => {
    const [stats, setStats] = useState({
        totalEnquiries: 0,
        recentEnquiries: 0,
        totalUsers: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await axios.get('http://localhost:5000/api/enquiry');
                setStats({
                    totalEnquiries: res.data.length,
                    recentEnquiries: res.data.filter(e => {
                        const date = new Date(e.createdAt);
                        const today = new Date();
                        return date.toDateString() === today.toDateString();
                    }).length,
                    totalUsers: 1 // We'll update this when we have a users endpoint
                });
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, []);

    const cards = [
        { name: 'Total Enquiries', value: stats.totalEnquiries, icon: <MessageSquare className="text-blue-600" />, color: 'bg-blue-50' },
        { name: 'Enquiries Today', value: stats.recentEnquiries, icon: <TrendingUp className="text-green-600" />, color: 'bg-green-50' },
        { name: 'Active Users', value: stats.totalUsers, icon: <Users className="text-purple-600" />, color: 'bg-purple-50' },
        { name: 'Pending Follow-ups', value: 0, icon: <Clock className="text-orange-600" />, color: 'bg-orange-50' },
    ];

    if (loading) {
        return <div className="animate-pulse flex space-x-4">Loading stats...</div>;
    }

    return (
        <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {cards.map((card, i) => (
                    <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-center justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500 mb-1">{card.name}</p>
                            <h3 className="text-2xl font-bold text-dark-green">{card.value}</h3>
                        </div>
                        <div className={`p-4 rounded-xl ${card.color}`}>
                            {card.icon}
                        </div>
                    </div>
                ))}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                    <h3 className="text-lg font-bold text-dark-green mb-6">Recent Activity</h3>
                    <p className="text-gray-500 text-sm">Dashboard is live. Tracking website enquiries in real-time.</p>
                </div>
                <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                    <h3 className="text-lg font-bold text-dark-green mb-6">System Status</h3>
                    <div className="flex items-center space-x-2">
                        <div className="w-2 h-2 bg-green-500 rounded-full animate-ping"></div>
                        <span className="text-sm font-medium text-gray-700">All systems operational</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
